<template>
  <EmailGrabberPopup
    @close="toggleGrabber"
    :grabberActive="grabberActive"
    :freePlan="freePlan"
    :payPlan="payPlan"
    :planId="planId"
    class="overflow-y-hidden"
  >
  </EmailGrabberPopup>
  <div>
    <!-- page meta -->
    <Head>
      <title>
        Kajabi vs. Platforma - The #1 Kajabi Alternative is Platforma
      </title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Build, host, and sell a hub for all your digital products. Monetize and protect your content."
      />
    </Head>
  </div>
  <!-- content start -->
  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!--  HERO SECTION  -->

    <section
      id="section1"
      class="hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
      :style="backgroundImageStyleMain"
    >
      <div class="mt-0 bg-transparent px-[25px] xl:px-0">
        <h1
          class="top-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          The #1 Alternative to Kajabi.
        </h1>

        <p
          class="mt-[5px] mb-[25px] text-[15px] font-medium text-[#7c828d] lg:text-lg"
        >
          Don’t get stuck in outdated tools. Build, engage, and sell more with
          Platforma’s powerful features and intuitive workflow—all in one place.
        </p>

        <!-- captcher email widget -->
        <EmailCaptureHeaderWidget />

        <img :src="$filters.media_path('/images/stars.svg')" alt="" />
      </div>

      <div class="mb-[30px] mt-[30px] lg:mt-0 z-10">
        <img
          loading="lazy"
          class="lg:max-w-[650px]"
          :src="
            $filters.media_path('/images/a-course-builder-like-kajabi-free.png')
          "
          alt="A website like Kajabi"
        />
      </div>
    </section>

    <div
      class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[150px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
    >
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      <h2
        class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
      >
        JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
      </h2>
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
    </div>

    <!-- ===================== DISCORD COMPARE TABLE HEADER SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[50px] lg:h-auto xl:hidden xl:px-0 2xl:hidden"
    >
      <div class="z-20 mt-12 w-full justify-center gap-5 py-0 lg:flex">
        <div class="mt-0 lg:mr-[110px] lg:text-left">
          <div id="text_header" class="text-xs font-extrabold text-[#2D8CFF]">
            COMPARE
          </div>

          <h2
            class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:max-w-[600px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Get everything Kajabi has and much more.
          </h2>

          <p
            class="mt-[15px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[600px]"
          >
            Platforma gives your enterprise a flexible marketing platform and
            hundreds of content paywall options to boost revenue—all for free to
            start.
          </p>
        </div>
      </div>
    </section>

    <div class="px-[25px] lg:px-0">
      <table class="w-full table-auto">
        <thead class="">
          <tr class="w-full">
            <th class="mt-0 lg:text-left">
              <div class="mb-10 hidden lg:w-full xl:block">
                <p
                  id="text_compare_top"
                  class="text-xs font-extrabold text-[#2D8CFF]"
                >
                  COMPARE
                </p>

                <h2
                  class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:max-w-[600px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
                >
                  Get everything Kajabi has and much more.
                </h2>

                <p
                  class="mt-[15px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-[600px]"
                >
                  Platforma gives your enterprise a flexible marketing platform
                  and hundreds of content paywall options to boost revenue—all
                  for free to start.
                </p>
              </div>
            </th>

            <th class="z-30 mx-auto mt-[25px] px-5 py-[15px] xl:mt-[30px]">
              <div
                class="relative mx-auto h-[85px] w-[60px] rounded-xl bg-white drop-shadow-[0_15px_15px_rgba(0,0,0,0.25)] lg:h-[205px] lg:w-[200px]"
              >
                <h3
                  class="my-auto pt-[30px] text-center text-[10px] font-bold text-[#292d34] lg:py-[73px] lg:text-[27px]"
                >
                  Kajabi
                </h3>

                <h3
                  class="absolute inset-x-0 bottom-0 rounded-b-xl bg-[#FD7171] text-center text-[10px] font-bold text-[#fff] lg:text-[27px]"
                >
                  MISSED IT
                </h3>
              </div>
            </th>

            <th
              class="z-30 mx-auto mt-[25px] ml-4 gap-5 px-5 py-[15px] xl:mt-[30px]"
            >
              <div
                class="relative mx-auto h-[85px] w-[60px] rounded-xl bg-white drop-shadow-[0_15px_15px_rgba(0,0,0,0.25)] lg:h-[205px] lg:w-[200px]"
              >
                <img
                  loading="lazy"
                  class="mx-auto px-1 pt-[15px] lg:w-[120px] lg:py-[45px]"
                  :src="
                    $filters.media_path('/images/platforma-logo-stacked.svg')
                  "
                  alt="membership site checkout page to sell subscriptions and digital products"
                />

                <h3
                  class="absolute inset-x-0 bottom-0 rounded-b-xl bg-[#00B888] text-center text-[10px] font-bold text-[#fff] lg:text-[27px]"
                >
                  GOT IT
                </h3>
              </div>
            </th>
          </tr>
        </thead>

        <tbody class="">
          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Interactive course members area
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Video Channel Libraries
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Live Streaming Webinars & Events
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Member Broadcast and Announcements
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              1-on-1 in app Video calls
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Live Chat
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Voice messages
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Video messages
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              3rd Party Cart Integrations
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Webinar Registration Pages
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Member Data
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Member Activity Tracking
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Private Data Servers
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
          <tr class="">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Advanced Course Drip Options
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>
            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] lg:w-[40px]"
              />
            </td>
          </tr>

          <tr class="bg-[#a0a3af10]">
            <td
              class="rounded-tl-[10px] rounded-bl-[10px] pl-[15px] text-sm font-bold text-[#292d34] lg:pl-[25px]"
            >
              Tags
            </td>
            <td class="align-middle">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-x.svg'
                  )
                "
                alt=""
                class="mx-auto my-[15px] w-[30px] lg:w-[40px]"
              />
            </td>

            <td class="rounded-tr-[10px] rounded-br-[10px]">
              <img
                :src="
                  $filters.media_path(
                    '/images/online-course-platform-alternative-plus.svg'
                  )
                "
                alt=""
                class="mx-auto w-[30px] rounded-tr-[10px] rounded-br-[10px] lg:w-[40px]"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- ===================== IMPORT SECTION ===================== -->
    <section
      class="relative mt-[70px] w-full justify-center gap-2 px-[25px] lg:mx-auto lg:mt-[150px] lg:flex lg:h-[500px] lg:flex-row-reverse xl:px-0"
    >
      <div class="text-left lg:mx-0 lg:max-w-[500px] lg:px-[30px]">
        <div
          id="text_optimize"
          class="text-xs font-extrabold text-[#00b884] lg:left-0"
        >
          OPTIMIZE
        </div>

        <h2
          class="top-full mt-[20px] px-0 text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          Leaving the dark side is easy.
        </h2>

        <div class="mb-[50px]">
          <hr
            class="ml-0 mt-[30px] h-[5px] w-[100px] rounded-full bg-[#00b884]"
          />
        </div>

        <div class="flex py-[10px]">
          <img
            :src="
              $filters.media_path(
                '/images/green-circle-checkmark-icon-platforma.svg'
              )
            "
            alt=""
            class="w-[28px]"
          />

          <h4 class="pl-[10px] text-lg font-medium text-[#292d34]">
            HD Video Channel Libraries
          </h4>
        </div>

        <div class="flex py-[10px]">
          <img
            :src="
              $filters.media_path(
                '/images/green-circle-checkmark-icon-platforma.svg'
              )
            "
            alt=""
            class="w-[28px]"
          />

          <h4 class="pl-[10px] text-lg font-medium text-[#292d34]">
            Courses, groups, streaming.
          </h4>
        </div>

        <div class="flex py-[10px]">
          <img
            :src="
              $filters.media_path(
                '/images/green-circle-checkmark-icon-platforma.svg'
              )
            "
            alt=""
            class="w-[28px]"
          />

          <h4 class="pl-[10px] text-lg font-medium text-[#292d34]">
            Switching Is Easy
          </h4>
        </div>

        <button
          @click="toggleGrabber('free', null)"
          type="button"
          class="import-button my-[25px] h-[50px] w-[250px] rounded-[4px] bg-[#2d8bff] bg-[right_16px_top_19px] bg-no-repeat pl-[15px] text-left text-[14px] font-bold text-white drop-shadow-[0px_10px_25px_#64A7F9] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none"
        >
          Move from Kajabi Now
        </button>
      </div>

      <div
        class="mx-auto mt-12 justify-center gap-1 py-0 md:z-10 lg:mt-0 lg:px-0"
      >
        <img
          loading="lazy"
          class="lg:w-[650px]"
          :src="$filters.media_path('/images/kajabi-transfer-bg.svg')"
          alt="platform analytics dashboard allows you to track everything within your site."
        />
      </div>
    </section>
  </div>
  <!-- SEXY TESTIMONIALS SECTION -->
  <section
    class="testimonial-blue-quotes mx-auto mt-[50px] lg:mt-[100px] max-w-[1200px] px-[25px] text-center xl:px-0"
  >
    <CarouselTestimonialBlueQuotes
      :pagination="true"
      :timeout="6000"
      class="carousel xl:w-[1100px] md:h-[450px] h-[350px] pt-[50px] bg-none relative mx-auto my-auto py-0"
      v-slot="{ currentSlide }"
    >
      <SlideBlueQuotesTestimonials
        v-for="(slideBlueQuotesTestimonials, index) in carouselSlides"
        :key="index"
      >
        <div
          v-show="currentSlide == index + 1"
          class="slide-info absolute mx-auto bg-none w-full h-full rounded-[10px] sm:rounded-[60px]"
        >
          <img
            :src="
              $filters.media_path(`/images/${slideBlueQuotesTestimonials}.png`)
            "
            alt="Build your own podcast delivery website on your own domain to make more revenue from your Podcast."
            class="mx-auto md:w-[800px] shadow-2xl"
          />
        </div>
      </SlideBlueQuotesTestimonials>
    </CarouselTestimonialBlueQuotes>
  </section>
  <!-- ============= EMAIL INTEGRATIONS ============= -->
  <EmailIntegrationsSlider />
  <!-- =============COMPARE SECTION START============= -->
  <!-- COMPARE HEADLINES -->
  <section class="mx-[25px] mt-[145px] text-center">
    <div class="text-center">
      <div
        id="text_compare"
        class="text-center text-xs font-bold tracking-wide text-[#2D8CFF]"
      >
        COMPARE
      </div>

      <h2
        class="px-auto top-full mt-[20px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        Get more for less with Platforma.
      </h2>

      <p
        class="mt-[20px] text-sm font-medium leading-[25px] text-[#7c828d] xl:max-w-full"
      >
        All of Platforma's features come with a single price tag.
        <br />
        Kajabi offers less and requires you to download lots of software to make
        it better.
      </p>
    </div>
  </section>
  <!-- COMPARE INFOGRAPHS -->
  <!-- ======== PLATFORMA WINNER STATS ========== -->
  <section
    class="compare-section mx-auto mt-[50px] p-[40px] lg:bg-cover lg:bg-no-repeat xl:h-[440px] xl:w-[1280px]"
  >
    <div
      class="mx-auto rounded-[10px] bg-white pt-[50px] shadow-2xl lg:flex lg:pt-0 xl:h-[125px] xl:w-[1200px]"
    >
      <div
        class="mb-[40px] lg:mb-0 lg:border-r-2 lg:border-[#E9EBF0] lg:px-[30px] lg:pt-[30px]"
      >
        <img
          :src="$filters.media_path('/images/platforma-logo-stacked.svg')"
          alt=""
          class="mx-auto w-[100px]"
        />
      </div>

      <div
        class="lg:px-auto w-full justify-between py-[25px] md:flex md:px-[20px]"
      >
        <div class="">
          <img
            :src="
              $filters.media_path(
                '/images/online-course-icon-platforma-blue.svg'
              )
            "
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">Courses</h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/icon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="
              $filters.media_path('/images/streaming-icon-platforma-blue.svg')
            "
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">
            Streaming
          </h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/icon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="$filters.media_path('/images/chat-icon-platforma-blue.svg')"
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">Chat</h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/gicon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="
              $filters.media_path('/images/facetime-icon-platforma-blue.svg')
            "
            alt=""
            class="mx-auto mb-[14px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">Facetime</h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/icon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="
              $filters.media_path('/images/quizzes-icon-platforma-blue.svg')
            "
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">Quizzes</h4>
        </div>

        <div class="mx-auto mt-[20px] hidden md:block lg:my-auto">
          <img
            :src="
              $filters.media_path(
                '/images/equals-icon-platforma-best-online-course-platform.svg'
              )
            "
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] flex justify-center md:my-auto">
          <div class="my-auto mr-5 content-end md:mx-auto md:hidden">
            <img
              :src="
                $filters.media_path(
                  '/images/equals-icon-platforma-best-online-course-platform.svg'
                )
              "
              alt=""
              class="my-auto w-[19px]"
            />
          </div>

          <div class="mt-[20px] md:mx-auto md:my-auto">
            <h4
              class="text-right text-[50px] font-semibold leading-none text-[#2D8CFF]"
            >
              $74
            </h4>
            <h5 class="text-right text-lg font-bold text-[#B9BEC7]">
              PER MONTH
            </h5>
          </div>
        </div>
      </div>
    </div>

    <!-- =============VS============= -->

    <div class="mx-auto mt-[30px] flex max-w-[970px]">
      <div class="my-auto h-[3px] w-[450px] bg-[#e9eaec]"></div>

      <div class="mx-[15px] w-[100px] lg:w-[50px]">
        <img
          :src="$filters.media_path('/images/vs-grey-icon.svg')"
          alt=""
          class="mx-auto lg:h-[50px]"
        />
      </div>

      <div class="my-auto h-[3px] w-[450px] bg-[#e9eaec]"></div>
    </div>

    <!-- =============LOSER STATS============ -->

    <div
      class="mx-auto mt-[30px] rounded-[10px] bg-white pt-[50px] shadow-2xl lg:flex lg:pt-0 xl:h-[125px] xl:w-[850px]"
    >
      <div
        class="mx-auto border-[#E9EBF0] px-[30px] text-center lg:border-r-2 lg:py-10"
      >
        <h3 class="text-center text-[27px] font-bold text-[#292d34]">Kajabi</h3>
      </div>

      <div
        class="lg:px-auto w-full justify-between py-[25px] md:flex md:px-[20px]"
      >
        <div class="">
          <img
            :src="$filters.media_path('/images/courses-red-icon.svg')"
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">Courses</h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/icon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="$filters.media_path('/images/landing-pages-red-icon.svg')"
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">
            Landing Pages
          </h4>
        </div>

        <div class="mx-auto mt-[20px] lg:my-auto">
          <img
            :src="$filters.media_path('/images/icon-plus-more-features.svg')"
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] md:my-auto">
          <img
            :src="$filters.media_path('/images/courses-red-icon.svg')"
            alt=""
            class="mx-auto mb-[10px]"
          />
          <h4 class="text-center text-lg font-bold text-[#292d34]">
            Mini-Courses
          </h4>
        </div>

        <div class="mx-auto mt-[20px] hidden md:block lg:my-auto">
          <img
            :src="
              $filters.media_path(
                '/images/equals-icon-platforma-best-online-course-platform.svg'
              )
            "
            alt=""
            class="mx-auto my-auto w-[19px]"
          />
        </div>

        <div class="mx-auto mt-[20px] flex justify-center md:my-auto">
          <div class="my-auto mr-5 content-end md:mx-auto md:hidden">
            <img
              :src="
                $filters.media_path(
                  '/images/equals-icon-platforma-best-online-course-platform.svg'
                )
              "
              alt=""
              class="my-auto w-[19px]"
            />
          </div>

          <div class="mt-[20px] md:mx-auto md:my-auto">
            <h4
              class="text-right text-[50px] font-semibold leading-none text-[#FD7171]"
            >
              $399
            </h4>
            <h5 class="text-right text-lg font-bold text-[#B9BEC7]">
              PER MONTH
            </h5>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- ===================== CTA BLOCK ===================== -->
  <CtaBlock cta-headline="Level up from Kajabi and earn 37% more revenue." />
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
export default {
  layout: DefaultLayout
};
</script>

<script setup>
import { ref, computed } from 'vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import EmailCaptureHeaderWidget from '../Components/EmailCaptureHeader.vue';
import TestimonialSliderBlueQuotes from '../Components/TestimonialSliderBlueQuotes.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import CarouselTestimonialBlueQuotes from '../Components/CarouselTestimonialBlueQuotes.vue';
import SlideBlueQuotesTestimonials from '../Components/SlideBlueQuotesTestimonials.vue';
import CtaBlock from '../Components/CtaBlockFooterComponent.vue';
import EmailGrabberPopup from '../Components/EmailGrabberPopup.vue';
import Axios from 'axios';

const grabberActive = ref(false);
const freePlan = ref(false);
const payPlan = ref(false);
const planId = ref(null);
const carouselSlides = [
  'testimonial-blue-1-vs-kajabi',
  'testimonial-blue-2-vs-kajabi',
  'testimonial-blue-3-vs-kajabi'
];

const toggleGrabber = (plan, id) => {
  if (plan === 'free') {
    freePlan.value = true;
    payPlan.value = false;
    planId.value = null;
  }
  if (plan === 'pay') {
    payPlan.value = true;
    planId.value = id;
    freePlan.value = false;
  }
  grabberActive.value = !grabberActive.value;
};

const backgroundImageStyleMain = computed(() => {
  const imagePath =
    '../../../../media/images/platforma-header-background-eclipse.svg';
  return {
    '--before-background-image': `url(${imagePath})`
  };
});
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.compare-section {
  background-image: url(../media/images/VS-DOTS.svg);
  /* background-size: cover; */
}
.import-button {
  background-image: url(../media/images/Arrow-right-white-icon.svg);
  /* background-size: cover; */
}
.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}

.testimonial-blue-quotes {
  background-image: url(../media/images/two-dots.svg);
}
</style>
